import React from "react";

import * as actions from "@/redux/RecipeReducer";
import * as dashboardActions from "@/redux/DashboardReducer";
import { wrapper } from "@/redux/Store";
import RecipeSlugListingPage from "@/containers/RecipeSlugListingPage";
import { checkRecipeSlugType } from "@/containers/RecipeSlugListingPage/util";

const RecipePage = ({ postData }: any) => {
  return (
    <>
      <RecipeSlugListingPage postData={postData} />
    </>
  );
};

export default RecipePage;

export const getServerSideProps = wrapper.getServerSideProps(
  (store: any) =>
    async ({ query }: any) => {
      await store.dispatch(
        dashboardActions.getRibbonData({ pathname: "recipes" })
      );

      const recipeSlug = query?.recipeSlug?.[0];
      const { isAttributeType, isCollectionType, isRecipeType, slug } =
        checkRecipeSlugType(recipeSlug);

      let postData = {};

      if (isAttributeType) {
        const res = await store.dispatch(
          actions.getRecipeByAttributeSlug({ id: slug })
        );

        postData =
          {
            data: res?.payload?.data?.results?.data,
            ...res?.payload?.data?.results?.header_data,
          } || {};
      } else if (isCollectionType) {
        const res = await store.dispatch(
          actions.getRecipeByCollectionSlug({ id: slug })
        );
        postData =
          {
            data: res?.payload?.data?.results?.data,
            ...res?.payload?.data?.results?.header_data,
          } || {};
      } else if (isRecipeType) {
        const res = await store.dispatch(
          actions.getRecipeThreadByID({ id: slug })
        );
        postData = res?.payload?.data || {};
      }
      return { props: { postData } };
    }
);
